module.exports = __webpack_public_path__ + "img/region.06df869.png";